import { call, put, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";
import * as actionTypes from "../ActionTypes";

import {
  saveLanguageMetaSuccess,
  saveLanguageMetaFailure,
} from "./action.js";

import { saveLanguageMeta } from "./language.js";

// ✅ Save Language Meta Saga
function* saveLanguageMetaSaga(action) {
  try {

    const { apiPayloadRequest } = action.payload;

    // Validate input
    if (!apiPayloadRequest?._id || !apiPayloadRequest?.language_code) {
      throw new Error("Missing required fields (_id or language_code).");
    }

    const response = yield call(saveLanguageMeta, apiPayloadRequest);

    if (response?.type === 1) {
      yield put(saveLanguageMetaSuccess(response));
      toast.success("Language Meta saved successfully!");
      if (action.callback) action.callback({ type: 1, data: response });
    } else {
      throw new Error(response?.error || "Failed to save language meta.");
    }
  } catch (error) {
    yield put(saveLanguageMetaFailure(error.message));
    toast.error(error.message);
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

// ✅ Watcher
export default function* languageMetaWatcherSaga() {
  yield takeLatest(
    actionTypes.SAVE_LANGUAGE_META_REQUEST,
    saveLanguageMetaSaga
  );
}
